import { useState } from 'react';
import { AllApplicationPermissions } from '../Config/PermissionConfig';
import { isUserAuthorised } from './usePermissionLoader';

type UsePermission = {
    [name: string]: AllApplicationPermissions | AllApplicationPermissions[];
};

export function useAnyPermission(permissions: AllApplicationPermissions[]) {
    for (const permissionsKey of permissions) {
        if (isUserAuthorised(permissionsKey)) return true;
    }

    return false;
}

export function usePermissions<T extends UsePermission>(permissions: T): { [P in keyof T]?: boolean } {
    const [permissionsResults] = useState(() => {
        return Object.entries(permissions).reduce(
            (
                currentPermissions,
                nextPermissions: [string, AllApplicationPermissions | AllApplicationPermissions[]]
            ) => {
                return {
                    ...currentPermissions,
                    [nextPermissions[0]]: isUserAuthorised(nextPermissions[1])
                };
            },
            {}
        );
    });

    return permissionsResults;
}
